import React, { useState } from 'react';
import SearchBar from '../common/Searchbar';
import closeIcon from '../../assets/images/closeIcon.svg';
import { useDispatch } from 'react-redux';
import { DQBElement } from '../../types/DQB';
import DQBList from './DQBList';
import { setDQBOpen } from '../../features/DQB/DQBOpenSlice';

interface DQBModalProps {
    dqbItems: DQBElement[];
    bookId: any
}

const DQBModal: React.FC<DQBModalProps> = ({ dqbItems, bookId }) => {
    const [searchTerm, setSearchTerm] = useState<string>('');

    const dispatch = useDispatch();

    const handleDQBClose = () => {
        dispatch(setDQBOpen(false));
    };

    // Filter chapters based on the search term
    const filteredDqbItems = dqbItems.filter((dqbItem) =>
        dqbItem.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="modal-overlay fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center w-full h-full z-50 ">
            <div className="modal bg-white pb-6 pt-4 px-12 rounded-xl shadow-lg flex flex-col font-sans lg:w-[60rem] h-[40rem]">
                <div className="flex justify-between">
                    <div className="flex items-center">
                        <h1 className="text-2xl text-black text-nowrap">DQB</h1>
                        <SearchBar
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            placeHolder="Search DQB"
                        />
                    </div>
                    <div>
                        <button
                            className="mt-2"
                            onClick={handleDQBClose}
                            data-testid="dqb-modal-close-button"
                        >
                            <img src={closeIcon} alt="close icon" />
                        </button>
                    </div>
                </div>
                <hr className="border-solid border-gray-300 mt-4 -mx-12" />

                <div className="overflow-y-scroll custom-scrollbar">
                    <DQBList dqbItems={filteredDqbItems} bookId={bookId} />
                </div>
            </div>
        </div>
    );
};

export default DQBModal;
